import { FC } from 'react';

import Image from 'molecules/Image';

import { FlexibleComparisonColumnProps } from 'components/Tables/FeatureComparisonTable/config';

const FlexibleColumnTitle: FC<Pick<FlexibleComparisonColumnProps, 'title' | 'showPrismaticLogo'>> = ({
  title,
  showPrismaticLogo,
}) =>
  showPrismaticLogo ? (
    <>
      <Image
        url="/prismatic-logo.svg"
        alt="Prismatic"
        className="h-[29px] w-[143px] object-contain object-left lg:h-[34px] lg:w-40"
      />
      <span className="sr-only">Prismatic</span>
    </>
  ) : (
    <span className="font-spaceGrotesk text-2xl font-medium leading-8 text-white">{title}</span>
  );

export default FlexibleColumnTitle;
